// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"71":"02ba6324","189":"91ff1b85"}[chunkId] + ".css";
};